/**
 * Unified Alchema logo — "Alchem" text + geometric cube as "a".
 * Uses em-based sizing so it scales with the parent font-size.
 * Set the size via className or style={{ fontSize: "..." }}.
 *
 * The center hero logo is the canonical reference for proportions,
 * weight, glow, and cube alignment. All instances must match it.
 */
export function AlchemaLogo({
  className = "",
  style,
  darkBg = false,
  glow = true,
}: {
  className?: string;
  style?: React.CSSProperties;
  /** When true, renders white text + white icon. When false, uses currentColor. */
  darkBg?: boolean;
  /** When true, adds ethereal glow (text-shadow + icon blur layers). Default: true */
  glow?: boolean;
}) {
  const textColor = darkBg ? "rgba(255,255,255,0.85)" : "currentColor";
  const textShadow = glow && darkBg
    ? "0 0 8px rgba(255,255,255,0.4), 0 0 20px rgba(255,255,255,0.2), 0 0 50px rgba(255,255,255,0.1)"
    : undefined;
  const iconFilter = darkBg ? undefined : "brightness(0)";
  const iconOpacity = darkBg ? 0.85 : 1;

  return (
    <span
      className={`alchema-logo ${className}`}
      style={{
        display: "inline-flex",
        alignItems: "baseline",
        lineHeight: 1,
        ...style,
      }}
    >
      <span
        style={{
          fontFamily: "var(--font-display), system-ui, sans-serif",
          fontWeight: 300,
          letterSpacing: "-0.03em",
          color: textColor,
          lineHeight: 1,
          textShadow,
        }}
      >
        Alchem
      </span>
      <span style={{ position: "relative", display: "inline-flex", alignItems: "flex-end", alignSelf: "flex-end", marginBottom: "-0.05em", marginLeft: "-0.06em" }}>
        {glow && darkBg && (
          <img src="/logo-block.svg" alt="" aria-hidden="true" style={{ position: "absolute", inset: "-20%", height: "140%", width: "auto", filter: "blur(12px)", opacity: 0.4 }} />
        )}
        <img
          src="/logo-block.svg"
          alt=""
          aria-hidden="true"
          style={{
            position: "relative",
            height: "0.95em",
            width: "auto",
            filter: iconFilter,
            opacity: iconOpacity,
          }}
        />
      </span>
    </span>
  );
}
